export enum IdStatusType {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  LOST = 'lost',
  STOLEN = 'stolen',
}

export enum LegalizationType {
  APOSTILLE = 'apostille',
  CONSULAR_LEGALIZATION = 'consularLegalization',
  NOTARIZATION = 'notarization',
  OTHER = 'other',
}

export enum StorageLocationType {
  HOME = 'home',
  OFFICE = 'office',
  SAFE_DEPOSIT_BOX = 'safeDepositBox',
  DIGITAL_STORAGE = 'digitalStorage',
  OTHER = 'other',
}

export enum AcquisitionType {
  BUSINESS = 'business',
}

export enum DriversLicenseCategory {
  a = 'a',
  a1 = 'a1',
  b = 'b',
  b1 = 'b1',
  c = 'c',
  c1 = 'c1',
  d = 'd',
  d1 = 'd1',
  be = 'be',
  ce = 'ce',
  de = 'de',
  c1e = 'c1e',
  d1e = 'd1e',
  m = 'm',
  tm = 'tm',
  tb = 'tb',
  other = 'other',
}

export enum BasisType {
  rental = 'rental',
  ownership = 'ownership',
}

export enum BloodType {
  A_PLUS = 'A+',
  A_MINUS = 'A-',
  B_PLUS = 'B+',
  B_MINUS = 'B-',
  O_PLUS = 'O+',
  O_MINUS = 'O-',
  AB_PLUS = 'AB+',
  AB_MINUS = 'AB-',
}
